@if (prevTo) {
  <a class="no-decoration" (click)="prevTo()">
    <app-button buttonType="outline">
      <app-prev-next type="prev" />
    </app-button>
  </a>
}
<div class="next-submit-wrap">
  @if (showRequiredFieldsHint && (nextTo || submitTo)) {
    <span class="required-fields-hint" role="alert">{{ requiredFieldsHintText }}</span>
  }
  @if (nextTo) {
    <a id="next" class="no-decoration" (click)="nextTo()">
      <app-button buttonType="filled">
        <app-prev-next type="next" />
      </app-button>
    </a>
  } @else if (submitTo) {
    <a id="next" class="no-decoration" (click)="submitTo()">
      <app-button buttonType="filled"> Submit </app-button>
    </a>
  }
</div>
